import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import Auth from "./pages/Auth.tsx";
import OriActivation from "./pages/OriActivation.tsx";
import Dashboard from "./pages/Dashboard.tsx";
import Onboarding from "./pages/Onboarding.tsx";
import OnboardingIntro from "./pages/OnboardingIntro.tsx";
import Admin from "./pages/Admin.tsx";
import BrainCenter from "./pages/BrainCenter.tsx";
import Pricing from "./pages/Pricing.tsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";
import TermsOfService from "./pages/TermsOfService.tsx";
import RefundPolicy from "./pages/RefundPolicy.tsx";
import NotFound from "./pages/NotFound.tsx";
import Demo from "./pages/Demo.tsx";
import DemoDashboard from "./pages/DemoDashboard.tsx";
import GscSelectProperty from "./pages/GscSelectProperty.tsx";
import GscCallback from "./pages/GscCallback.tsx";
import AdminConnectGsc from "./pages/AdminConnectGsc.tsx";
import GoogleAdsCallback from "./pages/GoogleAdsCallback.tsx";
import Blog from "./pages/Blog.tsx";
import BlogArticle from "./pages/BlogArticle.tsx";
import SiteBlog from "./pages/SiteBlog.tsx";
import SiteBlogArticle from "./pages/SiteBlogArticle.tsx";
import ScrollToTop from "./components/ScrollToTop.tsx";
import Workspace from "./pages/Workspace.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/activate" element={<OriActivation />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/workspace" element={<Workspace />} />
          <Route path="/workspace/manual" element={<Workspace />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/onboarding-intro" element={<OnboardingIntro />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/connect-gsc" element={<AdminConnectGsc />} />
          <Route path="/admin/brain" element={<BrainCenter />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/demo" element={<DemoDashboard />} />
          <Route path="/demo/:clientId" element={<Demo />} />
          <Route path="/index" element={<Index />} />
          <Route path="/gsc-select-property" element={<GscSelectProperty />} />
          <Route path="/gsc-callback" element={<GscCallback />} />
          <Route path="/google-ads-callback" element={<GoogleAdsCallback />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/sites/:clientSlug/blog" element={<SiteBlog />} />
          <Route path="/sites/:clientSlug/blog/:slug" element={<SiteBlogArticle />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
